import { inject, Injectable } from '@angular/core';
import { ServicesService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class ReadersEndpointService {
  readonly #service = inject(ServicesService);

  readers() {
    return this.#service.vesta('reader');
  }

  reader(readerId: string) {
    return this.#service.vesta(`reader/${readerId}`);
  }

  updateReader(readerId: string) {
    return this.#service.vesta(`reader/${readerId}`);
  }

  publishReader(readerId: string) {
    return this.#service.vesta(`reader/${readerId}/publish`);
  }

  archiveReader(readerId: string) {
    return this.#service.vesta(`reader/${readerId}/archive`);
  }
}
